import 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const rawUrlTemplate = `https://storage.cloud.google.com/our-assets.appspot.com/`
const urlTemplate = `https://storage.cloud.google.com/our-assets.appspot.com/images/`
const PhotoModule = {
  firestorePath: 'photos',
  firestoreRefType: 'collection',
  moduleName: 'PhotoModule',
  statePropName: 'photos',
  namespaced: true,
  sync: {
    defaultValues: {
      name: '',
      description: '',
      itemRef: '',
      archived: false,
      processed: true,
      data: '',
      originalUrl: '',
      objects: [],
      logos: [],
      text: [],
      scanned: false
    }
  },
  getters: {
    get: (state) => {
      let photos = Object.values(state.photos).filter(photo => !photo.archived)
      // photos.done = true
      for (let i = 0; i < photos.length; i++) {
        let photo = photos[i]
        photo.imageUrl = photo.data
        // console.log(photo)
        if (!photo.data.includes('.jpg', '.jpeg')) {
          photos[i].fullSizeUrl = `${rawUrlTemplate}${photo.data}.jpg`
          photos[i].imageUrl = `${urlTemplate}${photo.data}_640x640.jpeg`
          photos[i].data = `${urlTemplate}${photo.data}_640x640.jpeg`
        }
      }

      return photos

      // return Object.values(state.photos).filter(photo => !photo.archived)
    },
    getById: (state) => (id) => {
      var photos = Object.values(state.photos)
      var photo = {name: '', data: ''}
      for (var i = 0; i < photos.length; i++) {
        photo = photos[i]
        if (photo.id === id) {
          if (!photo.data.includes('.jpg')) {
            photos[i].fullSizeUrl = `${rawUrlTemplate}${photo.data}.jpg`
            photos[i].imageUrl = `${urlTemplate}${photo.data}_640x640.jpeg`
            photos[i].data = `${urlTemplate}${photo.data}_640x640.jpeg`
          }
          break
        }
      }

      return photo
    }
  },
  actions: {
    create: ({dispatch}, payload) => {
      var photo = {
        // data: payload.data,
        itemRef: payload.itemRef,        
        created_by: payload.created_by,
      }

      return dispatch('insert', photo)
    },
    setUrl: ({dispatch}, payload) => {
      var photo = {
        id: payload.id,
        data: payload.originalUrl,
        itemRef: payload.itemRef,
        imageUrl: payload.originalUrl,
        // fullSizeUrl: payload.photoUrl,
        // thumbUrl: payload.thumbUrl
      }

      dispatch('patch', photo)
    },
    save: ({dispatch}, payload) => {
      var photo = {
        id: payload.id,
        name: payload.name,
        description: payload.description,
        data: payload.data,
        itemRef: payload.itemRef
      }

      dispatch('patch', photo)
    },
    updateOwner: ({dispatch}, payload) => {
      dispatch('patch', {id: payload.id, created_by: payload.created_by})
    },
    addMetadata: ({dispatch}, payload) => {
      dispatch('patch', {id: payload.id, objects: payload.objects, logos: payload.logos, text: payload.text, scanned: true})
    },
    archive: ({dispatch}, payload) => {
      dispatch('patch', {id: payload.id, archived: true})
    }
  }
}

export default PhotoModule